export enum ActionTypes {
  SET_MODAL_CONFIG = 'SET_MODAL_CONFIG',
  LOADING = 'LOADING',
  SERVERLOG = 'SERVERLOG',
  GET_TRACKTRACE = 'GET_TRACKTRACE',
  SET_NOTIFICATION = 'SET_NOTIFICATION',
  SET_CLIENT_CONFIG = 'SET_CLIENT_CONFIG',
}

export interface ReduxAction {
  type: ActionTypes;
  payload?: any;
}
